import shadowDOM from "components/Stacker/utils/shadowDOM"

export function pointDist(point, p1, p2, edge, res, rot) {
  const { x, y } = point
  const x1 = p1[0]
  const y1 = p1[1]
  const x2 = p2[0]
  const y2 = p2[1]

  const A = x - x1
  const B = y - y1
  const C = x2 - x1
  const D = y2 - y1

  const dotProd = A * C + B * D
  let distSq = C * C + D * D
  const determ = dotProd / distSq

  let xx
  let yy

  if (determ < 0 || (x1 === x2 && y1 === y2)) {
    xx = x1
    yy = y1
  } else if (determ > 1) {
    xx = x2
    yy = y2
  } else {
    xx = x1 + determ * C
    yy = y1 + determ * D
  }

  const dx = x - xx
  const dy = y - yy

  distSq = dx * dx + dy * dy
  if (distSq < res.distSq) {
    res.edge = edge
    res.dist = Math.sqrt(distSq)
    res.distSq = distSq
    res.point.x = xx
    res.point.y = yy
    res.rot = rot
  }

  return res
}

export function getRotation(p1, p2) {
  const dx = p2[0] - p1[0]
  const dy = p2[1] - p1[1]
  const DEG = 180 / Math.PI
  return Math.atan2(dy, dx) * DEG
}

export function hitTest(point, points) {
  const total = points.length - 1

  let res = {
    edge: 0,
    point: {},
    dist: Infinity,
    distSq: Infinity,
    rot: 0,
  }

  for (let i = 0; i < total; i++) {
    const p1 = points[i]
    const p2 = points[i + 1] || points[0]
    const rot = getRotation(p1, p2)
    res = pointDist(point, p1, p2, i, res, rot)
  }
  return res
}

export function getComputedTranslateXY(obj) {
  const transArr = []
  const style = getComputedStyle(obj)
  const transform =
    style.transform || style.webkitTransform || style.mozTransform
  let mat = transform.match(/^matrix3d\((.+)\)$/)
  if (mat) return parseFloat(mat[1].split(", ")[13])
  mat = transform.match(/^matrix\((.+)\)$/)
  if (mat) transArr.push(parseFloat(mat[1].split(", ")[4]))
  else transArr.push(0)
  if (mat) transArr.push(parseFloat(mat[1].split(", ")[5]))
  else transArr.push(0)
  return transArr
}

export function getComputedPositions() {
  const items = Array.from(shadowDOM.getElementsByClassName("amulet-anim"))
  return items.map((el) => {
    return getComputedTranslateXY(el)
  })
}

export function wrapQueryArray(arr) {
  if (!arr) return []
  return Array.isArray(arr) ? arr : [arr]
}
